const verification_record = {
    not_found: 'Verification record not found.',
    permission_denied: 'Permission denied, please re-authenticate.',
};
export default Object.freeze(verification_record);
